import { defineComponent as _defineComponent } from 'vue'
import { useAiLab } from '@/composables/use-ai-lab';
import History from '@/presentation/components/history/History.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { aiLabService } = useAiLab();
aiLabService.initAiLab();

return { __sfc: true,aiLabService, History }
}

})